<script>
    import ProviderAddHeader from '@/components/page-provider-and-game-edit/provider-add/ProviderAddHeader.vue';
    import ProviderAddData from '@/components/page-provider-and-game-edit/provider-add/ProviderAddData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_PAG_PROVIDER_ADD}
        },
        components: {
            ProviderAddHeader: ProviderAddHeader,
            ProviderAddData: ProviderAddData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <ProviderAddHeader />
        <hr class="hr_light_98">
        <ProviderAddData />
    </div>
</template>